// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6756d0b7","453":"ab4e7b16","455":"5d7cf9ad"}[chunkId] + ".chunk.js";
};